import React, { useState } from 'react';

const TrustRegistration = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with Trust registration.',
     website_hp: ''
  });

 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with Trust registration.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Trust Registration
            </h1>
            <p className="mt-4 text-xl text-blue-100">
              Essential for non-profit, charitable, or religious activities. We provide end-to-end assistance for public and private trust formation in India, ensuring compliance with the Indian Trusts Act.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">📈</span> Start Trust Operations
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Registration Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of Trust Registration
              </h2>
              <h3 className="text-2xl font-bold text-blue-600 mb-4">
                Understanding Trusts and Trust Registration in India
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                Trusts are valuable structures often established with philanthropic goals, aiming to advance areas like science, literature, poverty alleviation, education, and healthcare. Registering a trust under the Indian Trusts Act, 1882, is a critical step to ensure its legal recognition and operation within the established legal framework. Online trust registration provides legal validity and establishes the trust as a distinct legal entity.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                If you are considering forming a trust for non-profit or charitable purposes in India, official registration is essential for effective operation and compliance with legal obligations. At Akir Advisory, our dedicated team of professionals is equipped to guide you through every stage of the trust registration process, including obtaining your trust registration certificate. We are here to clarify your doubts and simplify the process of how to register a trust in India, aiming to provide you with a seamless and efficient online trust registration experience.
              </p>
              <h3 className="text-2xl font-bold text-blue-600 mb-4">
                Trust & Trust Registration - An Overview
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                Individuals establish trusts to allocate assets or property for the benefit of another. A trust involves a fiduciary relationship between the trustor (the person establishing the trust), the trustee (responsible for managing the trust), and the beneficiary (who receives the benefits). These roles are defined in the trust deed during the registration process.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                A trust is created when the trustor transfers a specific asset or property to the trustee for the ultimate benefit of the beneficiary, who is typically a third party potentially connected to both the trustor and trustee. The relationship between these parties is fundamental to the definition of a trust. As per the Indian Trusts Act, 1882, a trust is defined as a "Relationship between the trustor and trustee to hold specific benefits for the beneficiary."
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Charitable Involvement:</strong> Allows for contributing to charitable causes while also potentially benefiting individuals or families.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Tax Exemptions:</strong> Registered trusts can avail tax relaxations under the Income Tax Act.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Financial Support:</strong> Enables the provision of financial assistance through charitable activities.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Legal Protection:</strong> The Indian Trusts Act, 1882, provides legal safeguarding for the trust's standing.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Family Wealth Protection:</strong> Assists in preserving and managing family assets.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Probate Avoidance:</strong> Can streamline asset distribution to heirs.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Immigration/Emigration Benefits:</strong> May offer advantages for asset management and taxation when relocating.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with Trust registration." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for Trust Registration
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "📊", title: "Decide Trust Name and Type", desc: "Choose a unique name for the trust, ensuring it complies with the relevant laws. Decide whether the trust is public (charitable/religious) or private (for individuals or family)." },
              { number: "02", icon: "🔒", title: "Settle Trustees and Settlor", desc: "Identify the settlor (person forming the trust) and trustees (persons who will manage it). Typically, a minimum of two trustees is required." },
              { number: "03", icon: "🏢", title: "Draft the Trust Deed", desc: "Prepare the trust deed, which is the principal legal document containing objectives, rules, powers, rights, and duties of trustees and beneficiaries." },
              { number: "04", icon: "📄", title: "Prepare Supporting Documents", desc: "Gather supporting documents – trust deed, IDs, photographs, and address proofs of settlor and trustees. If any property is being settled, include its documentation." },
              { number: "05", icon: "✍️", title: "Execute the Trust Deed", desc: "Get the trust deed typed on a non-judicial stamp paper (the value depends on state laws). All trustees and the settlor must sign it in the presence of two witnesses." },
              { number: "06", icon: "✅", title: "Registration at Sub-Registrar's Office", desc: "Submit the signed trust deed and documents to the local Sub-Registrar office in the jurisdiction where the trust's registered office will be. All parties must be present with two witnesses." },
              { number: "07", icon: "🖋️", title: "Verification and Registration", desc: "The Sub-Registrar checks all documents, verifies identities, and registers the trust deed officially." },
              { number: "08", icon: "💼", title: "Obtain Trust Registration Certificate", desc: "Upon verification, the Sub-Registrar registers the deed and issues a Trust Registration Certificate, after which the trust can open its bank account and begin operations." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Only Scanned Copies are required
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Mandatory Documents for Trust Registration
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "👥", title: "Trust Deed", desc: "The core legal document outlining the trust's objectives, rules, trustees, beneficiaries, and property. Must be executed on non-judicial stamp paper of appropriate value." },
              { icon: "📍", title: "Identity Proof of Settlor and Trustees", desc: "PAN Card (mandatory), Aadhaar Card, Voter ID, Passport size photographs of the settlor and each trustee, Passport, or Driving License for all settlors and trustees involved in the trust" },
              { icon: "🏢", title: "Address Proof of the Trust", desc: "Ownership papers of the registered office (if owned) or a rent/lease agreement and No Objection Certificate (NOC) from the landlord (if rented). Recent utility bill can also be submitted as proof." },
              { icon: "📝", title: "No Objection Certificate (NOC)", desc: "Issued by the property owner if the registered office is on rented premises." },
              { icon: "📋", title: "12A & 80G", desc: "12A and 80G certificates (if seeking income tax benefits)." },
              { icon: "🎓", title: "Other Supporting Documents", desc: "Any other document required by state regulators or the Sub-Registrar, based on local jurisdiction (varies by state/region)." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 text-center">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "📋", title: "Trust Deed (Registered Copy)", desc: "Official registered document—this is the core legal evidence of the trust's existence and governs its functioning." },
              { icon: "📚", title: "Trust Registration Certificate", desc: "Issued by the local Sub-Registrar or other authority, this certificate legally recognizes your trust as a formal entity." },
              { icon: "🆔", title: "Legal Entity Status", desc: "Your trust acquires independent legal status, enabling it to own property, enter into contracts, and operate bank accounts in its name." },
              { icon: "💰", title: "PAN Card for the Trust", desc: "Permanent Account Number (PAN) for your registered trust, necessary for banking and tax compliance." },
              { icon: "🛡️", title: "Additional Benefits", desc: "Tax Benefits (12A & 80G), Access to Govt/CSR Funding, Legal Protection & Credibility, Compliance Capability, Bank Account Opening" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      Trust FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">Who can register a trust in India?</h4>
                      <p className="text-gray-600">Any individual, group of individuals, or company can register a trust, provided they are legally capable and not disqualified by law.</p>
                  </div>
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">What is a Trust Deed and why is it important?</h4>
                      <p className="text-gray-600">A Trust Deed is the main legal document that defines the objectives, rules, powers, and operations of the trust. It is mandatory for registration and future trust management.</p>
                  </div>
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">What are the registration fees or stamp duty for a trust?</h4>
                      <p className="text-gray-600">Stamp duty varies by state, based on trust property value, registration location, and type of trust. Check your local state stamp act for details.</p>
                  </div>
                  <div className="border rounded-lg p-5 shadow-sm">
                      <h4 className="font-semibold text-lg text-gray-900 mb-2">What benefits do I get after trust registration?</h4>
                      <p className="text-gray-600">You receive a registered trust deed/certificate, legal entity status, bank account access, and eligibility for tax exemptions and government funding.</p>
                  </div>
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready to Form Trust?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our team of advisors simplify your Trust Registration journey.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📞</span> Consult Our Expert Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default TrustRegistration;